import { render, staticRenderFns } from "./edit-transferencia.vue?vue&type=template&id=0e000eb5"
import script from "./edit-transferencia.vue?vue&type=script&lang=ts"
export * from "./edit-transferencia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports